module.exports = __webpack_public_path__ + "static/media/sign_up_right_side.03e10e27.svg";